import { IncidentTypesEmpty } from "HelperFiles/Constants";
import { checkValidLogin } from "HelperFiles/DashboardHelper";
import { generateAnalyticSummaryPageData } from "HelperFiles/DataGenerator";

// action
export const setIsLoggedIn = (data) => ({ type: 'IS_LOGGED_IN', payload: data });
// Reducers
export const setIsLoggedInReducer = (
  state = checkValidLogin(), action = { type: '', payload: checkValidLogin() }
) => {
  if (action.type === 'IS_LOGGED_IN') { return action.payload; } else { return state; }
};
// Selectors
export const getIsLoggedIn = (state) => state.isLoggedIn;

/////////////////////////////////////////////////////////////////////

// action
export const setDashboardConfig = (data) => ({ type: 'DASHBOARD_CONFIG', payload: data });
// Reducers
export const setDashboardConfigReducer = (state = '', action = { type: '', payload: '' }) => {
  if (action.type === 'DASHBOARD_CONFIG') { return action.payload; } else { return state; }
};
// Selectors
export const getdashboardConfig = (state) => state.dashboardConfig;

/////////////////////////////////////////////////////////////////////

// action
export const setApplicationConfig = (data) => ({ type: 'APPLICATION_CONFIG', payload: data });
// Reducers
export const setApplicationConfigReducer = (state = '', action = { type: '', payload: '' }) => {
  if (action.type === 'APPLICATION_CONFIG') { return action.payload; } else { return state; }
};
// Selectors
export const getApplicationConfig = (state) => state.applicationConfig;

/////////////////////////////////////////////////////////////////////

// action
export const setEnabledRoutes = (data) => ({ type: 'ENABLED_ROUTES', payload: data });
// Reducers
export const setEnabledRoutesReducer = (state = [], action = { type: '', payload: [] }) => {
  if (action.type === 'ENABLED_ROUTES') { return action.payload; } else { return state; }
};
// Selectors
export const getEnabledRoutes = (state) => state.enabledRoutes;

/////////////////////////////////////////////////////////////////////

// action
export const setLocationSelected = (data) => ({ type: 'LOCATION_SELECTED', payload: data });
//middleware
export const setLocationSelectedMidlleware =
  ({ dispatch, getState }) =>
    (next) =>
      (action) => {
        next(action);
        if (action.type == 'LOCATION_SELECTED') {
          const analyticSummaryPageData = generateAnalyticSummaryPageData({
            wholeData: getState().wholeData,
            locationSelected: action.payload,
            cameraSelected: getState().cameraSelected,
            cameraData: getState().cameraData,
            locationsData: getState().locationsData,
            searchStartDate: getState().searchStartDate,
            searchEndDate: getState().searchEndDate,
            allIncidents: getState().allIncidents,
            selectedIncidents: action.payload,
            applicationConfig: getState().applicationConfig
          });

          dispatch(setAnalyticSummaryPageData(analyticSummaryPageData));
        }
      }
// Reducers
export const setLocationSelectedReducer = (state = '', action = { type: '', payload: '' }) => {
  if (action.type === 'LOCATION_SELECTED') { return action.payload; } else { return state; }
};
// Selectors
export const getLocationSelected = (state) => state.locationSelected;

/////////////////////////////////////////////////////////////////////

// action
export const setCameraSelected = (data) => ({ type: 'CAMERA_SELECTED', payload: data });
//middleware
export const setCameraSelectedMidlleware =
  ({ dispatch, getState }) =>
    (next) =>
      (action) => {
        next(action);
        if (action.type == 'CAMERA_SELECTED') {
          const analyticSummaryPageData = generateAnalyticSummaryPageData({
            wholeData: getState().wholeData,
            locationSelected: getState().locationSelected,
            cameraSelected: action.payload,
            cameraData: getState().cameraData,
            locationsData: getState().locationsData,
            searchStartDate: getState().searchStartDate,
            searchEndDate: getState().searchEndDate,
            allIncidents: getState().allIncidents,
            selectedIncidents: action.payload,
            applicationConfig: getState().applicationConfig
          });

          dispatch(setAnalyticSummaryPageData(analyticSummaryPageData));
        }
      }
// Reducers
export const setCameraSelectedReducer = (state = '', action = { type: '', payload: '' }) => {
  if (action.type === 'CAMERA_SELECTED') { return action.payload; } else { return state; }
};
// Selectors
export const getCameraSelected = (state) => state.cameraSelected;

/////////////////////////////////////////////////////////////////////

// action
export const setSearchStartDate = (data) => ({ type: 'SEARCH_START_DATE', payload: data });
// Reducers
export const setSearchStartDateReducer = (
  state = new Date(new Date().getTime() - 3600 * 1000),
  action = { type: '', payload: new Date(new Date().getTime() - 3600 * 1000) }) => {
  if (action.type === 'SEARCH_START_DATE') { return action.payload; } else { return state; }
};
// Selectors
export const getSearchStartDate = (state) => state.searchStartDate;

/////////////////////////////////////////////////////////////////////

// action
export const setSearchEndDate = (data) => ({ type: 'SEARCH_END_DATE', payload: data });
// Reducers
export const setSearchEndDateReducer = (
  state = new Date(new Date().setHours(23, 59, 59, 999)),
  action = { type: '', payload: new Date(new Date().setHours(23, 59, 59, 999)) }) => {
  if (action.type === 'SEARCH_END_DATE') { return action.payload; } else { return state; }
};
// Selectors
export const getSearchEndDate = (state) => state.searchEndDate;

/////////////////////////////////////////////////////////////////////

// action
export const setCameraData = (data) => ({ type: 'CAMERA_DATA', payload: data });
// Reducers
export const setCameraDataReducer = (state = [], action = { type: '', payload: [] }) => {
  if (action.type === 'CAMERA_DATA') { return action.payload; } else { return state; }
};
// Selectors
export const getCameraData = (state) => state.cameraData;

/////////////////////////////////////////////////////////////////////

// action
export const setLocationsData = (data) => ({ type: 'LOCATIONS_DATA', payload: data });
// Reducers
export const setLocationsDataReducer = (state = [], action = { type: '', payload: [] }) => {
  if (action.type === 'LOCATIONS_DATA') { return action.payload; } else { return state; }
};
// Selectors
export const getLocationsData = (state) => state.locationsData;

/////////////////////////////////////////////////////////////////////

// action
export const setWholeData = (data) => ({ type: 'WHOLE_DATA', payload: data });
// Reducers
export const setWholeDataReducer = (state = [], action = { type: '', payload: [] }) => {
  if (action.type === 'WHOLE_DATA') { return action.payload; } else { return state; }
};
// Selectors
export const getWholeData = (state) => state.wholeData;

/////////////////////////////////////////////////////////////////////

// action
export const setAutoRefreshTime = (data) => ({ type: 'AUTO_REFRESH_TIME', payload: data });
// Reducers
export const setAutoRefreshTimeReducer = (state = 0, action = { type: '', payload: 0 }) => {
  if (action.type === 'AUTO_REFRESH_TIME') { return action.payload; } else { return state; }
};
// Selectors
export const getAutoRefreshTime = (state) => state.autoRefreshTime;

/////////////////////////////////////////////////////////////////////

const initialChartsData = {
  barChartData: {
    chartData: [],
    chartColors: null
  },
  pieChartData: {
    chartData: [],
    chartColors: null
  },
  timeLineData: [],
  videoData: []
}

export const initialAnalyticSummaryPageData = {
  boxesPacked: 0,
  fillErrors: 0,
  boxFillOK: 0,
  underFillBoxes: 0,
  overFillBoxes: 0,
  boxFillOkPercentage: 0,
  underFillPercentage: 0,
  overFillPercentage: 0,
  qualityDistributionData: initialChartsData,

  machineUpTime: 0,
  machineDownTime: 0,
  percentageMachineUp: 0,
  percentageMachineDown: 0,
  idleTime: 0,
  percentageMachineUtilization: 0,
  changeoverTime: 0,
  percentageChangeover: 0,
  unfinishedPartCount: 0,
  reworkedPartCount: 0,
  rackWithPartCount: 0,
  emptyRackDetectedCount: 0,
  cHookWithRackCount: 0,
  cHookWithoutRackCount: 0,
  numberPlateDetectedCount: 0,

  machineUpdownData: initialChartsData,
  machineUtilizationData: initialChartsData,
  changeoverData: initialChartsData,
  partsData: initialChartsData,
  racksData: initialChartsData,
  cHookData: initialChartsData,

  statCardData: [],
  barChartData: {
    chartData: [],
    chartColors: null
  },
  pieChartData: {
    chartData: [],
    chartColors: null
  },
  timeLineData: [],
  videoData: [],
  eventReplyData: []
}

// action
export const setAnalyticSummaryPageData = (data) => ({ type: 'ANALYTIC_SUMMARY_PAGE_DATA', payload: data });
// Reducers
export const setAnalyticSummaryPageDataReducer = (
  state = initialAnalyticSummaryPageData,
  action = { type: '', payload: initialAnalyticSummaryPageData }) => {
  if (action.type === 'ANALYTIC_SUMMARY_PAGE_DATA') { return action.payload; } else { return state; }
};
// Selectors
export const getAnalyticSummaryPageData = (state) => state.analyticSummaryPageData;

/////////////////////////////////////////////////////////////////////

const InitialStationHistogramPageData = {
  tableData: [],
  partsPresent: 0,
  partsMissing: 0,
  extraParts: 0,
  totalParts: 0,
  predictedStatus: '',
  overrideStatus: '',
  thumbnail: '',
  incidentLocationName: '',
  incidentCameraName: '',
  incident: {},
  exportFileName: 'DoriAIVisionScanReport'
}

// action
export const setStationHistogramPageData = (data) => ({ type: 'STATION_HIST_PAGE_DATA', payload: data });
// Reducers
export const setStationHistogramPageDataReducer = (
  state = InitialStationHistogramPageData,
  action = { type: '', payload: InitialStationHistogramPageData }
) => {
  if (action.type === 'STATION_HIST_PAGE_DATA') { return action.payload; } else { return state; }
};
// Selectors
export const getStationHistogramPageData = (state) => state.stationHistogramPageData;

/////////////////////////////////////////////

// action
export const setAllIncidents = (data) => ({ type: 'ALL_INCIDENTS', payload: data });
// Reducers
export const setAllIncidentsReducer = (
  state = IncidentTypesEmpty,
  action = { type: '', payload: IncidentTypesEmpty }
) => {
  if (action.type === 'ALL_INCIDENTS') { return action.payload; } else { return state; }
};
// Selectors
export const getAllIncidents = (state) => state.allIncidents;

/////////////////////////////////////////////

// action
export const setSelectedView = (data) => ({ type: 'SELECTED_VIEW', payload: data });
// Reducers
export const setSelectedViewReducer = (
  state = 'barchart',
  action = { type: '', payload: 'barchart' }
) => {
  if (action.type === 'SELECTED_VIEW') { return action.payload; } else { return state; }
};
// Selectors
export const getSelectedView = (state) => state.selectedView;